import React, { useMemo, useEffect } from "react";
// COMPONENTS
import { performancePages } from "../../../../constants";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
// queries
import { getMarketShareByChannelTable, getMarketShareByChannelTrend } from "../../../../api/brandPerformanceApi";
import Ratings from "../../../../components/Ratings/NewRatings";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import BrandPerformanceTableTile from "../BrandPerformanceTableTile";
import { isNullOrUndefined } from "../../../../utils/utilityFunctions";

interface Props extends RouteComponentProps {
  activePage: performancePages;
  diff: number;
  onHandleRadioClick: any;
  nissanCompetitor: string;
  granularity: string;
}

const ShareByChannelContent = withRouter((props: Props) => {
  const { activePage, diff, history, onHandleRadioClick, nissanCompetitor, granularity } = props;

  const params = useSelector((state: RootStateOrAny) => state.parameters);

  //   const marketShareTrendData = []

  // fetch the trend and average data
  const {
    data: marketShareByChannelTrendData,
    isFetching: loadingMarketShareByChannelTrendData,
    refetch: refetchMarketShareByChannelTrendData,
  } = useQuery(
    ["marketShareByChannelTrendData", granularity, history.location.search],
    () => getMarketShareByChannelTrend({ ...params, nissan_competitor: nissanCompetitor }),
    {
      enabled: false,
    }
  );

  const {
    data: marketShareByChannelTableData,
    isFetching: loadingMarketShareByChannelTableData,
    refetch: refetchMarketShareByChannelTableData,
  } = useQuery(
    ["marketShareByChannelTableData", granularity, history.location.search],
    () => getMarketShareByChannelTable({ ...params, nissan_competitor: nissanCompetitor }),
    {
      enabled: false,
    }
  );

  // when the url changes, refetch the data
  useEffect(() => {
    refetchMarketShareByChannelTableData();
    refetchMarketShareByChannelTrendData();
  }, [history.location.search]);

  const columns = [
    {
      id: "model",
      Header: `Brand `,
      accessor: "model",
      defaultCanSort: true,
      sortDescFirst: true,
      sortType: "alphanumericIgnoreCase",
      Cell: (props1: { value: string }) => {
        const { value } = props1;

        return value;
      },
    },
    {
      Header: "MS",
      accessor: `market_share`,
      id: "market_share",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "alphanumericCustom",
      Cell: (props: { cell: { row: { original: any } } }) => {
        const {
          cell: {
            row: { original },
          },
        } = props;
        const value = original?.["market_share"];
        return !isNullOrUndefined(value) ? `${value}%` : "n/a";
      },
    },
    {
      Header: "YoY",
      accessor: `market_share_yoy`,
      id: "market_share_yoy",
      defaultCanSort: true,
      defaultSortDesc: true,
      sortDescFirst: true,
      sortType: "basicCustom",
      Cell: (props: { cell: { row: { original: any } } }) => {
        const {
          cell: {
            row: { original },
          },
        } = props;
        const value = original?.["market_share_yoy"];
        return (
          <div className="sub-text">
            <span>{!isNullOrUndefined(value) && <Ratings value={value} />}</span>
            <span>{!isNullOrUndefined(value) ? `${value}%` : "n/a"} </span>{" "}
          </div>
        );
        // return !isNullOrUndefined(value) ? `${value}%` : "n/a";
      },
    },
  ];

  const dateRange = marketShareByChannelTableData?.date_range ?? [];

  const dateTitle = useMemo(() => {
    if (dateRange && dateRange.length > 1) {
      return `(${dateRange[0]} - ${dateRange.slice(-1)})`;
    }

    return "";
  }, [dateRange]);

  return (
    <div className="sales-by-volume-main-content">
      <BrandPerformanceTrendTile
        chartData={marketShareByChannelTrendData}
        title="Market Share By Channel"
        chartId="marketShareTrend"
        loadingTrend={loadingMarketShareByChannelTrendData}
        diff={diff}
        nissanCompetitor={nissanCompetitor}
        onHandleRadioClick={onHandleRadioClick}
        isPercentage={true}
        chartGranularity={granularity}
      />
      <BrandPerformanceTableTile
        title=""
        tableId="market_by_share_table"
        tableData={marketShareByChannelTableData}
        columns={columns}
        loadingTable={loadingMarketShareByChannelTableData}
        initialSortCol={{ id: "market_share", desc: true }}
      />
    </div>
  );
});

export default ShareByChannelContent;
